export enum TrailerMake {
    Unknown = -1,
    Vanguard = 0,
    Manac = 1,
    Trailmobile = 2,
    Utility = 3,
    Transcraft = 4,
    Dorsey = 5
}

export const TrailerMakeMetadata = {
    '-1': {
        display: 'Unknown',
        value: -1
    },
    '0': {
        display: 'Vanguard',
        value: 0
    },
    '1': {
        display: 'Manac',
        value: 1
    },
    '2': {
        display: 'Trailmobile',
        value: 2
    },
    '3': {
        display: 'Utility',
        value: 3
    },
    '4': {
        display: 'Transcraft',
        value: 4
    },
    '5': {
        display: 'Dorsey',
        value: 5
    }
};
